import { render, staticRenderFns } from "./InstantIcon.vue?vue&type=template&id=8c057ed4&"
import script from "./InstantIcon.vue?vue&type=script&lang=js&"
export * from "./InstantIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports